'use strict';
(function () {
  var _controller = 'identificationType.component.controller'
  angular.module('pentaApp')
    .controller(_controller, controller)
    .component('identificationType', {
      templateUrl: 'components/identificationType/identificationType.component.jade',
      controller: _controller,
      bindings: {
        model: '=', 
        required: '@',
        // '=': Two Way Binding, lo que cambia acá, cambia en el controlador padre automáticamente
        // '<': One Way Binding (RECOMENDADO), para recibir variables, funciones, etc
        // '@': String, para recibir strings, puede ser una bandera por ejemplo
        // '&': Dinámico, se ejecuta lo que está adentro, hay que pasarle un objeto con variables 
        //      ej: componente(call-back='algo(var)')  y en el controller callBack({var: 'esto'})
      }
    })

  controller.$inject = ['$scope', '$element'];
  function controller($scope, $element) {
    // METHODS

    // VARS
    var that = this;

    // WATCHERS
    $scope.$on('$destroy', onDestroy);

    // INIT

    /// On component init
    this.$onInit = function () {
      $scope.identificationNumberTypes = (profile
        && profile.enterprise
        && profile.enterprise.identificationNumberTypes
        && profile.enterprise.identificationNumberTypes.length) ? profile.enterprise.identificationNumberTypes : ['DNI', 'CUIT', 'RUT']
    };

    /////////////////////

    function onDestroy() {
      $scope.$root.abortRequests(_controller);
    }
    //// FIN CTRL
  }
})();
